/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const investmentNeedResourceDtoSchema = z.object({
  label: z.optional(z.string()),
  url: z.optional(z.string()),
});
